<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  created(){  //载入前
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }
 
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  methods: {
    //页面刷新
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted(){
    
  }
}
</script>

<style lang='scss'>
$backgrund: blue;
*{
  box-sizing: border-box;
  margin: 0;
}
#app{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
width:8px !important;
height: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0) !important;
border-radius:10px !important;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
border-radius:6px !important;
background:rgba(0,0,0,0.1) !important;
-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.5) !important;
}
::-webkit-scrollbar-thumb:window-inactive {
background:rgba(0,0,0,0.2) !important;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/App.vue